import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { formatPrice } from '../../utils';
import './Price.module.css';

const Price = ({
  children,
  currency,
  language,
  price,
  region,
  isMinPrice,
  ...props
}) => {
  const { t } = useTranslation();

  if (!price) {
    return null;
  }

  const formattedPrice =
    typeof price === 'number' ? formatPrice(price, language, currency) : price;

  return (
    <div {...props}>
      {isMinPrice
        ? t('Starting at {{price}}', {
            price: formattedPrice
          })
        : formattedPrice}
      {children && <div>{children}</div>}
      {region === 'de' ? <div styleName="vat">{t('excluding VAT')}</div> : null}
    </div>
  );
};

Price.defaultProps = {
  isMinPrice: false,
  price: null
};

export default connect(state => {
  return {
    language: state.i18n.language,
    currency: state.i18n.currency,
    region: state.i18n.region
  };
})(Price);
